module.exports = "https://web-assets.ifttt.com/packs/media/icons/deleted-c8948751.png";